import { useLayoutEffect } from "react";
import UnavailableProductHeader from "./UnavailableProductHeader/UnavailableProductHeader";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./UnavailableProduct.scss";
import classnamesBind from "classnames/bind";
import useRecommendations from "../mightLike/useRecommendations";
import getWindow from "../../utils/window";
import YouMightAlsoLike from "../youMightAlsoLike/YouMightAlsoLike";
import { isProductDiscontinued } from "../../../utils/productUtils";

const classnames = classnamesBind.bind(styles);

export default function UnavailableProduct() {
  const { getTranslation, product, isMobile } = useRuntimeConstants();

  const { hasFetchedRecs } = useRecommendations({
    productId: product?.id,
  });

  useLayoutEffect(() => {
    if (hasFetchedRecs) {
      const loader = getWindow().document.getElementById(
        "unavailable-skeleton-recs"
      );

      if (loader) {
        loader.parentElement.removeChild(loader);
      }
    }
  }, [hasFetchedRecs]);

  const discontinuedProduct = isProductDiscontinued(product);

  const headerTitle = discontinuedProduct
    ? getTranslation("pdp_discontinued_product_page_title")
    : getTranslation("pdp_unavailable_product_page_title");

  const headerSubTitle = discontinuedProduct
    ? getTranslation("pdp_discontinued_product_page_message")
    : getTranslation("pdp_unavailable_product_page_message");

  return (
    <section
      className={classnames(styles.section, {
        [styles.largeViewport]: !isMobile,
      })}
    >
      <UnavailableProductHeader title={headerTitle} message={headerSubTitle} />
      <YouMightAlsoLike />
    </section>
  );
}
